"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainAuthErrorMapping = void 0;
var final_form_1 = require("final-form");
function chainAuthErrorMapping(fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn.apply(void 0, args).catch(function (err) {
            var _a;
            return (_a = {},
                _a[final_form_1.FORM_ERROR] = errorMessage(err),
                _a);
        });
    };
}
exports.chainAuthErrorMapping = chainAuthErrorMapping;
function errorMessage(err) {
    if (typeof err === 'string') {
        return err;
    }
    if (!err) {
        return 'An error occurred.';
    }
    return err.message ? err.message : err.code;
}
//# sourceMappingURL=chainAuthErrorMapping.js.map